import { GlobalToken } from 'antd';

const getYearlyhGraphInitOptions = (t, token: GlobalToken) => ({
  title: {
    text: '',
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: token.colorBgContainer,
    type: 'column',
    marginLeft: 35,
    style: {
      fontSize: '9.6px',
      color: token.colorTextSecondary,
      fontFamily: 'Heebo',
    },
    height: '26%',
    spacingBottom: 0,
  },

  legend: {
    align: 'left',
    verticalAlign: 'top',
    itemMarginBottom: 25,
    x: -23,
    y: 0,
    labelFormatter() {
      switch (this.name) {
        case t('Baseline'):
        case t('Specific Power Baseline'):
          return `${this.name} <span class="graph-label-parentheses"> ${t('simulationValue')} </span>`;
        case t('Specific Power'):
        case t('Actual Energy'):
          return `${this.name} <span class="graph-label-parentheses"> ${t('actualValue')} </span>`;
        case t('Maintenance Event') && this.legendSymbol:
          this.legendSymbol.element.attributes.width.value = 20;
          this.legendSymbol.element.attributes.height.value = 20;
          this.legendSymbol.element.attributes.x.value = 3;
          this.legendSymbol.element.attributes.y.value = 5;
          return this.name;
        default:
          return this.name;
      }
    },

    itemStyle: {
      color: token.colorTextSecondary,
      fontFamily: 'Heebo',
      fontSize: '12px',
      fontWeight: 'normal',
      lineHeight: '20px',
    },

    useHTML: true,
    symbolHeight: 6,
    itemHoverStyle: {
      color: token.colorText,
    },
    itemHiddenStyle: {
      color: token.colorBorder,
    },
  },
});

export default getYearlyhGraphInitOptions;
